import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth, homeRouteFor } from '../contexts/AuthContext';

/**
 * Protège une route. `permission` est facultatif : sans lui, la route est
 * ouverte à tout utilisateur connecté. Avec lui, un utilisateur qui n'a pas
 * le droit est renvoyé vers sa page d'accueil plutôt que de voir un écran vide.
 */
export default function ProtectedRoute({ children, permission }) {
  const { isAuthenticated, isLoading, can, role } = useAuth();

  // Afficher un loader pendant la vérification
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 mx-auto mb-4 rounded-full border-2 border-sand-300 border-t-clay-500 animate-spin" />
          <p className="label-caps">Vérification en cours</p>
        </div>
      </div>
    );
  }

  // Rediriger vers login si pas authentifié
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Connecté, mais sans le droit d'accéder à cet écran
  if (permission && !can(permission)) {
    return <Navigate to={homeRouteFor(role)} replace />;
  }

  // Afficher le contenu protégé
  return children;
}
